module.exports = __webpack_public_path__ + "img/MIto_MaaS_logo_A.c0698aad.png";